// BaseNode.js
import { Handle } from 'reactflow';
import { NodeIcons } from './nodeIcons';

export const BaseNode = ({ id, data, title, children, handles = [], style = {}, selected }) => {
    const Icon = NodeIcons[data.nodeType] || NodeIcons[id.split('-')[0]] || NodeIcons.default; // Fallback logic

    return (
        <div
            className={`
        w-64 bg-cyber-gray rounded-xl shadow-[0_0_15px_rgba(0,0,0,0.5)] border 
        ${selected ? 'border-neon-blue ring-1 ring-neon-blue shadow-[0_0_20px_rgba(0,243,255,0.3)]' : 'border-gray-700'} 
        transition-all hover:shadow-[0_0_20px_rgba(0,243,255,0.15)] hover:border-gray-600
      `}
            style={style}
        >
            {/* Header */}
            <div className="flex items-center gap-2 px-4 py-3 border-b border-gray-700 bg-gray-900/50 rounded-t-xl backdrop-blur-sm">
                <Icon className="w-4 h-4 text-neon-purple" />
                <span className="text-sm font-semibold text-gray-100 font-orbitron tracking-wide">{title}</span>
            </div>

            {/* Body */}
            <div className="p-4 flex flex-col gap-3">
                {children}
            </div>

            {/* Handles */}
            {handles.map((handle, index) => (
                <Handle
                    key={handle.id || `${id}-handle-${index}`}
                    type={handle.type}
                    position={handle.position}
                    id={handle.id}
                    className={`
            !w-3 !h-3 !border-2 !border-cyber-gray 
            ${handle.type === 'target' ? '!bg-neon-blue -ml-1.5 shadow-[0_0_10px_#00f3ff]' : '!bg-neon-purple -mr-1.5 shadow-[0_0_10px_#bc13fe]'}
            hover:!bg-white transition-colors
          `}
                    style={handle.style}
                />
            ))}
        </div>
    );
};
